import {
    BrowserUtils,
    ComponentElements,
    ComponentInjector,
    ComponentObject,
    ComponentSelector,
    ComponentSelectors,
    ComponentService,
    Inject,
    UIComponent
} from '@atypon/ui-utils';

class Texts extends ComponentObject {
    pbContext: string = document.querySelector('[name="pbContext"]')?.getAttribute('content');
}

class ClassList extends ComponentObject {
}

class Selectors extends ComponentSelectors {
    previewLink = '.smart-layout_preview-link:not([data-listener-added])';
}

class Elements extends ComponentElements<Selectors> {
    previewLink: Array<HTMLAnchorElement> = [];
}

interface SmartLayout extends ComponentService<Selectors, Elements, ClassList, Texts> { }

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class SmartLayout implements UIComponent {

    constructor(readonly wrapper: HTMLElement) { }

    initialize(): void {

        this.elements.initialize(this.wrapper);
        const PB = (window as any).PB;
        if (PB && PB.$) {
            PB.$(document.documentElement).on("WidgetReinit.smart-layout", () => {
                this.addEventListeners();
            });
        }
    }

    addEventListeners() {
        this.elements.previewLink = this.domUtils.getElements(this.selectors.previewLink);
        this.elements.previewLink.forEach((elm) => {
            elm.addEventListener("click", (event) => {
                this.handlePreviewLinkClick(event)
            })
            elm.setAttribute('data-listener-added', 'true');
        })
    }

    handlePreviewLinkClick(event: Event) {
        const target = event.target as HTMLElement;
        event.preventDefault();
        const href = target.getAttribute('href');
        const pbContextStrValue = this.texts.pbContext;
        const requestBody = `pbEdit=true&pbNoSession=true&pbContext=${pbContextStrValue}`;
        this.fetchPendingEdits(requestBody, href);
    }

    fetchPendingEdits(requestBody: string, href: string) {
        fetch('/pb/editor/pendingEdits', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: requestBody,
        })
            .then(response => response.json())
            .then(data => this.handleFetchSuccess(data, href))
            .catch(this.handleFetchError);
    }

    handleFetchSuccess(data: any, href: string) {
        if (data.pendingEdits.length > 0) {
            const reviewId = data.pendingEdits[0][0].id;
            window.open(`${href}#review?edit=${reviewId}`, '_blank');
        } else {
            window.open(href, '_blank');
        }
    }

    handleFetchError(error: Error) {
        console.error('Error:', error);
    }
}

export default SmartLayout;

export {
    Elements as SmartLayoutElements,
    Selectors as SmartLayoutSelectors,
    ClassList as SmartLayoutClassList,
    Texts as SmartLayoutTexts,
}